export default "__VITE_ASSET__zFhud7CN__"